export default __webpack_public_path__ + "static/media/12.182b0887.jpg";